var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chip',{staticClass:"number-chip"},[_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }